import { createTheme } from "@mui/material/styles";
import themeSCSS from "config/theme.scss";

const theme = createTheme({
  palette: {
    primary: {
      main: themeSCSS["palette-primary-main"],
    },
    secondary: {
      main: themeSCSS["palette-secondary-main"],
    },
    secondary2: {
      main: themeSCSS["palette-secondary2-main"],
    },
    error: {
      main: themeSCSS["palette-error-main"],
    },
  },
  components: {
     MuiTypography: {
    styleOverrides: {
      root: { fontSize: '0.8571428571428571rem',letterSpacing: 0 },
    },
  },
    // Error helper text typography and color
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontSize: '0.6428571428571428rem',
          lineHeight: 1.5,
          '&.Mui-error': {
            color: '#f44336',
          },
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontSize: '0.8571428571428571rem',
          letterSpacing: 0,
          '&.Mui-error': {
            color: '#f44336',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: '0.8571428571428571rem',
          letterSpacing: 0,
          '&.Mui-error': {
            color: '#f44336 !important',
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontSize: '0.8571428571428571rem',
          letterSpacing: 0,
          lineHeight: '1.1876em',
        },
      },
    },
    // Underline color on error for standard variant
    MuiInput: {
      styleOverrides: {
          input: {
          fontSize: '0.8571428571428571rem',
          letterSpacing: 0,
          lineHeight: '1.1876em',
        },
        underline: {
          '&.Mui-error:before': {
            borderBottomColor: '#f44336',
            borderBottomWidth: '2px',
          },
          '&.Mui-error:after': {
            borderBottomColor: '#f44336',
            borderBottomWidth: '2px',
          },
          
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          fontSize: '0.8571428571428571rem',
        },
      },
    },
    
    MuiSvgIcon: {
      defaultProps: {
        fontSize: '1.2857142857142856rem',
      },
      styleOverrides: {
        root: {
          // we will size dropdown icons via CSS utilities if needed
        },
      },
    },
    
  },
  mainLayout: {
    paddingLeft: themeSCSS["mainLayout-paddingLeft"],
    paddingRight: themeSCSS["mainLayout-paddingRight"],
  },
  smartViewSidebar: {
    width: themeSCSS["smartViewSidebar-width"],
  },
  sidebar: {
    backgroundColor: "#282828",
  },
  overrides: {
    MuiTableRow: {
      root: {
        height: "auto",
        "&.Mui-selected": {
          backgroundColor: "rgba(0, 0, 0, 0.08);",
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.15);",
          },
        },
        "&.MuiTableRow-hover": {
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.08);",
          },
        },
      },
    },
    
  },
});

export default theme;